import { render, staticRenderFns } from "./AllTeachers.vue?vue&type=template&id=eb0aabf8&"
import script from "./AllTeachers.vue?vue&type=script&lang=js&"
export * from "./AllTeachers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports